<template>
  <div>
    <pt-form-item label="添加至任务单：" labelWidth="120px" :required="true">
      <el-input style="display:none" v-model="form.taskId" data-vv-as="任务单" v-validate="'required'"></el-input>
      <el-button type="primary" plain @click.native="openDialog()">点击选择</el-button>
      <el-button type="primary" :loading="distributeLoading" plain @click.native="creatTask()">创建任务单</el-button>
      <div :class="$style['package-table-div']" class="page-background" v-if="form.taskId">
        <table :class="$style['package-table']">
          <th>
          <td>任务单编号</td>
          <td>所属委托单编号</td>
          <td>实验人员</td>
          <td>派单人</td>
          <td>操作</td>
          </th>
          <tr>
            <td>{{productionTaskDetail.serialNumber}}</td>
            <td>{{productionTaskDetail.billCode}}</td>
            <td>{{productionTaskDetail.labTester.name}}</td>
            <td>{{productionTaskDetail.creator}}</td>
            <td>
              <el-button type="text" @click="form.taskId = ''">移除</el-button>
            </td>
          </tr>
        </table>
      </div>

    </pt-form-item>
    <selectProductionTaskDialog :dialogVisible="showDialog" @close="closeDialog" @selectData="getTask" :pageSize="5" :clientId="form.agentProductContractId" :billId="order.billId" :onlyNoBill="!order.billId" :noDownLoad="true" :noExportOption="true"></selectProductionTaskDialog>
  </div>
</template>

<script>
// import orderDatas from '@/store/actions/datas/order'
import selectProductionTaskDialog from 'cps/common/select-production-task-dialog'
import {
  validate
} from 'utils/validate'
import {
  next
} from '../status.js'
const AbnormalReasonType = 'LAB_SAMPLES_RECEIVED__UNQUALIFIED_REASON'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  components: {
    selectProductionTaskDialog
  },
  computed: {
  },
  data () {
    return {
      curparams: {},
      options: [],
      title: '待分派',
      form: {
        taskId: ''
      },
      distributeLoading: false,
      showDialog: false,

      productionTaskDetail: {}
    }
  },
  methods: {
    getTask (val) {
      console.log('--------------', val)
      this.productionTaskDetail = val
      this.form.taskId = val.id
      this.showDialog = false
    },
    formValidata () {
      return validate(this, this.form)
    },
    getReason (val) {
      for (var i in this.options) {
        if (this.options[i].id === val) {
          return this.options[i].name
        }
      }
    },
    creatTask () {
      if(this.order.billCode){
        this.$router.push(`/distribute-task?isFromOrder=true&orderId=${this.order.id}&billCode=${this.order.billCode}`)
      }else{
        this.$router.push(`/distribute-task?isFromOrder=true&orderId=${this.order.id}`)
      }
      
    },

    next () {
      let data = {
        action: this.status,
        taskId: this.form.taskId,
        orderIds: [this.order.id],
        billId: this.order.billId,
        orderStatusDetail: {
          action: this.status,
          productionTaskDetail: this.productionTaskDetail
        }
      }
      return next.call(this, data)
    },
    getAbnormalReason () {
      this.$store.dispatch('getAbnormalReason', AbnormalReasonType).then(res => {
        this.options = res
        this.getReason()
      })
    },
    openDialog () {
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
    }
  },
  created () {
    this.getAbnormalReason()
  }
}

</script>

<style module lang="less">
.package-table-div {
    margin-top: 10px;
    padding: 10px 20px 30px;
    max-width: 800px;
  }
  .package-table {
    display: table !important;
    width: 100%;
    border-collapse: collapse !important;
    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row;
      padding: 0 !important;
      list-style-type: none;
      border-bottom: 1px solid #c6c9d3;
      color: #818181;
    }
    td {
      text-align: center;
    }
  }
</style>
